<template>
  <div>
    <van-nav-bar
      :title="title"
      fixed
      placeholder
      @click-right="$emit('rc')"
      z-index="999"
    >
      <template #left>
        <el-button type="text" icon="el-icon-arrow-left" v-if="l" @click="$emit('lc')">
          {{ l }}
        </el-button>
      </template>
      <!-- <template #right>
        <el-button type="text" v-if="l" @click="$emit('rc')">
          <i class="el-icon-bell" /> {{ r }}
        </el-button>
      </template> -->
    </van-nav-bar>
  </div>
</template>
<style scoped>
.el-button {
  margin: 0;
  color: v-bind(sGetConfig("color2"));
}
.van-tag {
  background-color: v-bind(sGetConfig("color2"));
  padding-left: 0.5rem;
  padding-right: 0.5rem;
  border-radius: 0;
  margin-right: 0.3rem;
}
.van-icon {
  color: v-bind(sGetConfig("color2"));
}
.tag0 {
  background-color: white;
}
</style>
<script>
export default {
  props: {
    title: String,
    l: String,
    r: String,
    type: String,
  },
  data() {
    return {};
  },
  methods: {},
};
</script>
